var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},React.createElement("path",{"data-name":"Path 104","d":"M4.31 9.45L0 4.94l1.2-1.2L4.3 7l6.78-7 1.2 1.2z","fill":"#26b060"}))));
}

IconCheckmark.defaultProps = {"viewBox":"0 0 12.28 9.45"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
